<template>
    
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'债权融资管理'},{name:'债权产品列表'}]" :title="'债权产品列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border"  ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">上架状态</span>
                        <el-select v-model="sendInfoOne.status" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in upDown"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">贷款类型</span>
                        <el-select v-model="loanTypeValue" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in loanType"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">发布日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="债权产品ID">
                </el-table-column>
                <el-table-column
                    prop="debtProductName"
                    show-overflow-tooltip
                    
                    label="产品名称">
                </el-table-column>
                <el-table-column
                    prop="loanTypeValue"
                    show-overflow-tooltip
                    
                    label="贷款类型">
                </el-table-column>
                <el-table-column
                    prop="bankName"
                    show-overflow-tooltip
                    
                    label="银行名称">
                </el-table-column>
                <el-table-column
                    prop="statusValue"
                    show-overflow-tooltip
                    
                    label="上架状态">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    prop="views"
                    show-overflow-tooltip
                    
                    label="浏览数">
                </el-table-column>
                <el-table-column
                    prop="applySize"
                    show-overflow-tooltip
                    label="客户申请真实数">
                </el-table-column>
                <el-table-column
                    prop="customerApplyBase"
                    show-overflow-tooltip
                    label="客户申请基数">
                </el-table-column>
                <el-table-column
                    prop="topWeight"
                    show-overflow-tooltip
                    label="置顶权重">
                </el-table-column>
                <el-table-column
                    fixed="right"
                    v-if="authorities.indexOf('sys:permission:background:debt:product:list:button:view') != -1 ||
                    authorities.indexOf('sys:permission:background:debt:product:list:button:status') != -1"
                    label="操作"
                    
                    width="300">
                    <template slot-scope="scope">
                        <el-button  size="small" type="primary" class="super" plain @click="updateJs(scope.row)">修改基数</el-button>
                    <el-button  size="small" type="primary" class="super" plain 
                                  @click="setTop(scope.row)">置顶</el-button>
                        <el-button size="small" type="primary" class="super" plain  v-if="authorities.indexOf('sys:permission:background:debt:product:list:button:view') != -1" @click="check(scope.row)">查看</el-button>
                        <el-button :disabled="scope.row.isEditable == 1" size="small" :type="scope.row.btnValue === '上架'?'success':'warning'" class="super" plain 
                                   v-if="authorities.indexOf('sys:permission:background:debt:product:list:button:status') != -1" @click="soldOut(scope.row)">{{scope.row.btnValue}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
        </div>
    
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import timeMixins from "@/mixins/timeFormat";
import Regular from "@/mixins/regular.js";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '2',
                label: '产品名称'
                }, {
                value: '3',
                label: '银行名称'
            },{
                value: '4',
                label: '发布账号'
            }],//检索下拉
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            loanTypeValue:'',
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                loanType:null,//贷款类型
                status:"",//上架状态
                id:"",//申请id
                userName:'',//发布账号
                bankName:'',//银行名称
                debtProductName:'',//债权产品名称
                startDate: null,//开始时间
                endDate: null,//结束时间
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            tableData:[],//表格数据
            currentPage:1,//当前页
            upDown:[],//上下架
            loanType:[],//贷款类型,
            totalSize:null,//总条数
            weight: void 0,// 置顶权限
            customerApplyBase: void 0 // 申请基数
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //查询
        retrieval:function(){},
        //获取字典
        getDic:function(){
            this.$axiosz.get('backstage/sysDict/isShow/UA_LS').then((r)=>{ //上下架
                if(r.code==200){
                    this.upDown = r.data
                }
            })
            this.$axiosz.get('backstage/sysDict/isShow/LOAN_TYPE').then((r)=>{ //贷款类型
                if(r.code==200){
                    this.loanType = r.data
                }
            })
        },
        getData(){
            this.loading = true
            if(this.dateS&&this.dateS.length>0){
                this.sendInfoOne.startDate=this.dateS[0];
                this.sendInfoOne.endDate=this.dateS[1];
            }else{
                this.sendInfoOne.startDate=null;
                this.sendInfoOne.endDate=null;
            }
            this.sendInfoOne.id = ''
            this.sendInfoOne.debtProductName = ''
            this.sendInfoOne.bankName = ''
            this.sendInfoOne.userName = ''
            if(this.getSelect=='1'){ //申请id
				if(!Regular.numPint.test(this.getValue)){
          this.loading = false
					this.$alert('债权产品ID为正整数');
					return
				}else{
					this.sendInfoOne.id=this.getValue;
				}
            }else if(this.getSelect=='2'){ //产品名称
                this.sendInfoOne.debtProductName=this.getValue;
            }else if(this.getSelect=='3'){ //银行名称
                this.sendInfoOne.bankName=this.getValue;
            }else if(this.getSelect=='4'){ //发布账号
                this.sendInfoOne.userName=this.getValue;
            }
            if(this.loanTypeValue){
                this.sendInfoOne.loanType=this.loanTypeValue;
            }
            this.$axiosc.get('backstage/debt/financing/all/list', {params: this.sendInfoOne}).then((r) => {
               this.loading = false
                if (r.code == 200) {
                    this.tableData=r.data.content;
                    this.totalSize=r.data.totalElements;
                } else {
                    this.$alert(r.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        },
        //表格排序
        sortChange:function({ column, prop, order }){
			let ord='';
            if(order=='ascending'){
                ord='asc';
            }else{
                ord='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=ord;
            this.getData();
        },
        //表格查看按钮
        check:function(row){
            this.$router.push({path:'/debtManagement/productDetail',query:{id:row.id,index:'/debtManagement/productList'}})
        },
        //表格上架按钮
        soldIn:function(row){
            this.$confirm('确认上架？', '上架', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {

                    this.$axiosc.put('backstage/debt/financing/shelfObtained/'+row.id).then(res=>{
                        if(res.code == 200){
                            this.getData()
                            this.$message({
                                type: 'success',
                                message: '上架成功!'
                            });
                            
                        }else{
                            this.$alert(res.msg)
                        }
                    })
                }).catch(() => {    
            });
        },
        //表格下架按钮
        soldOut:function(row){
            let btnValue=row.btnValue;
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axiosc.put('backstage/debt/financing/shelfObtained/'+row.id).then(res=>{
                        if(res.code == 200){
                            this.getData()
                            this.$message({
                                type: 'success',
                                message: btnValue+'成功!'
                            });
                            
                        }else{
                            this.$alert(res.msg)
                        }
                    })
                    
                }).catch(() => {    
            });
        },
        // 修改基数
        updateJs(row){
          const that = this
          that.customerApplyBase = row.customerApplyBase ||  void 0
            if (document.getElementById('customerApplyBase')) document.getElementById('customerApplyBase').value = row.customerApplyBase
            // if(document.getElementById('commentContent'))document.getElementById('commentContent').value = that.weight
            const h = that.$createElement
            that.$msgbox({
              title: '修改客户申请基数提示',
              type: 'warning',
              customClass: 'super_messages',
              message: h('div', {
                attrs: {
                  class: 'el-input'
                }
              }, [
                h('div', {
                  attrs: {
                    class: 'super_title'
                  }}, '用于门户首页债权产品的客户申请数=基数+真实数'),
                h('div', {
                attrs: {
                  class: 'super_flexs'
                }
              }, [
                  h('div', {
                    attrs: {
                      class: 'super_sub'
                    }
                  }, '客户申请基数：'),
                  h('input', {
                    attrs: {
                      class: 'el-input__inner super_day',
                      autocomplete: 'off',
                      rows: 1,
                      id: 'customerApplyBase',
                      placeholder:'请输入客户申请基数'
                    },
                    value: that.customerApplyBase,
                    on: { input: that.onCommentInputChanges}
                  })]),
                h('div', {
                  attrs: {
                    class: 'super_tip',
                    id: 'tip'
                  }}, that.errTip)
              ]),
              showCancelButton: true,
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /[^\d]/g,
              inputValue:that.weight,
              inputErrorMessage: '客户申请基数不能为空',
              inputValidator: (val) => {
                if (!val || val === null || val === '' || val === undefined) {
                  that.errTip = '客户申请基数不能为空'
                  document.getElementById('tip').textContent = that.errTip
                  document.getElementById('customerApplyBase').value = ''
                  return false
                } else {
                  that.errTip = ''
                  document.getElementById('tip').textContent = that.errTip
                  return true
                }
              },
              beforeClose: async(action, instance, done) => {
                if (action === 'confirm') {
                  const validate = instance.inputValidator(that.customerApplyBase)
                  if (!validate) return
                  const customerApplyBase = parseInt(that.customerApplyBase)
                  instance.confirmButtonLoading = true
                  instance.confirmButtonText = '提交中...'
                  that.$axiosc.put(`/backstage/debt/financing/customerApplyBase/${row.id}/${customerApplyBase}`).then(res=>{
                              if(res.code == 200){
                                  that.getData()
                                  that.$message({
                                      type: 'success',
                                      message: '修改成功!'
                                  });
                                  that.customerApplyBase= void 0
                  // eslint-disable-next-line require-atomic-updates
                  instance.confirmButtonLoading = false
                  // eslint-disable-next-line require-atomic-updates
                  done()
                              }else{
                                  that.$alert(res.msg)
                              }
                          })
                  
                } else {
                  instance.confirmButtonLoading = false
                  done()
                }
              }
            }).then(action => {
            })
            if(row.customerApplyBase)
            {
            setTimeout(() => {
              if(document.getElementById('customerApplyBase'))document.getElementById('customerApplyBase').value = row.customerApplyBase || ''
            }, 500);
            }
        },
        // 置顶
        setTop(row){
          const that = this
          that.weight = row.topWeight ||  void 0
            if (document.getElementById('commentContent')) document.getElementById('commentContent').value = row.topWeight
            // if(document.getElementById('commentContent'))document.getElementById('commentContent').value = that.weight
            const h = that.$createElement
            that.$msgbox({
              title: '置顶提示',
              type: 'warning',
              customClass: 'super_messages',
              message: h('div', {
                attrs: {
                  class: 'el-input'
                }
              }, [
                h('div', {
                  attrs: {
                    class: 'super_title'
                  }}, '列表将根据输入的权重值由大到小排列'),
                h('div', {
                attrs: {
                  class: 'super_flexs'
                }
              }, [
                  h('div', {
                    attrs: {
                      class: 'super_sub'
                    }
                  }, '置顶权重：'),
                  h('input', {
                    attrs: {
                      class: 'el-input__inner super_day',
                      autocomplete: 'off',
                      rows: 1,
                      id: 'commentContent',
                      placeholder:'列表将根据输入的权重值由大到小排列'
                    },
                    value: that.weight,
                    on: { input: that.onCommentInputChange}
                  })]),
                h('div', {
                  attrs: {
                    class: 'super_tip',
                    id: 'tip'
                  }}, that.errTip)
              ]),
              showCancelButton: true,
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /[^\d]/g,
              inputValue:that.weight,
              inputErrorMessage: '置顶权重不能为空',
              inputValidator: (val) => {
                if (!val || val === null || val === '' || val === undefined) {
                  that.errTip = '置顶权重不能为空'
                  document.getElementById('tip').textContent = that.errTip
                  document.getElementById('commentContent').value = ''
                  return false
                } else {
                  that.errTip = ''
                  document.getElementById('tip').textContent = that.errTip
                  return true
                }
              },
              beforeClose: async(action, instance, done) => {
                if (action === 'confirm') {
                  const validate = instance.inputValidator(that.weight)
                  if (!validate) return
                  const sort = parseInt(that.weight)
                  instance.confirmButtonLoading = true
                  instance.confirmButtonText = '提交中...'
                  that.$axiosc.put(`/backstage/debt/financing/saveTopWeight/${row.id}/${sort}`).then(res=>{
                              if(res.code == 200){
                                  that.getData()
                                  that.$message({
                                      type: 'success',
                                      message: '置顶成功!'
                                  });
                                  that.weight= void 0
                  // eslint-disable-next-line require-atomic-updates
                  instance.confirmButtonLoading = false
                  // eslint-disable-next-line require-atomic-updates
                  done()
                              }else{
                                  that.$alert(res.msg)
                              }
                          })
                  
                } else {
                  instance.confirmButtonLoading = false
                  done()
                }
              }
            }).then(action => {
            })
            if(row.topWeight)
            {
            setTimeout(() => {
              if(document.getElementById('commentContent'))document.getElementById('commentContent').value = row.topWeight || ''
            }, 500);
            }
        },
        // 自定义输入框绑定事件
    onCommentInputChange() {
      let val = document.getElementById('commentContent').value
      val = val.replace(/[^\d]/g, '')
      if (val) {
        this.weight = val
      } else this.weight = ''
    },
    // 自定义输入框绑定事件
    onCommentInputChanges() {
      let val = document.getElementById('customerApplyBase').value
      val = val.replace(/[^\d]/g, '')
      if (val) {
        this.customerApplyBase = val
      } else this.customerApplyBase = ''
    },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
    },
    mounted(){
        const that = this
        that.getDic();
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss">
.super_messages{
  
  .el-message-box__status{
      top:7px !important;
      font-size: 18px !important;
  }
  .super_title{
    font-size:14px;
    font-weight: 400;
    margin-bottom:10px;
    color:#E6A23C;
  }
  .super_tip{
    font-size: 12px;
    color:#F2637B;
    margin-top:5px;
  }
  .super_sub{
    margin-bottom:5px;
  }
  .super_flexs{
    display: flex;
    align-items: center;
    .super_day{
      width:70%;
    }
  }
}
</style>